import { Button, Modal, Select, TextInput } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import VendorApi from '../../Api/VendorApi';
import { Vendor } from '../../Models/Vendor';
import { useAppSelector } from '../../Reducers/store';
import CommonApi from '../../Api/CommonApi';
import { InventoryType } from '../../Models/InventoryType';
import { onlyNumberInput } from '../../Utils';
import { InventoryLoadIn } from '../../Models/InventoryLoadIn';
import InventoryApi from '../../Api/InventoryApi';
import { Inventory } from '../../Models/Inventory';

export default function AssetLoadInModal({
  show,
  setShow,
  assetId,
  getUserLatestInspection,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  assetId: number;
  getUserLatestInspection: () => Promise<void>;
}) {
  const { userModel } = useAppSelector((state) => state.user);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [vendorListData, setvendorListData] = useState<Vendor[]>([]);
  const [inventoryTypeListData, setinventoryTypeListData] = useState<
    InventoryType[]
  >([]);
  const [inventoryListData, setinventoryListData] = useState<Inventory[]>([]);

  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);

  const [formData, setFormData] = useState<InventoryLoadIn>({
    id: 0,
    vendorId: null,
    dateCreated: null,
    assetId: assetId,
    userId: userModel?.id ?? 0,
    quantity: null,
    rate: null,
    inventoryTypeId: null,
    ticketNumber: null,
    inventoryId: null,

    asset: null,
    inventoryType: null,
    user: null,
    vendor: null,
  });
  const handleResetFormValues = () => {
    const values = {
      id: 0,
      vendorId: null,
      dateCreated: null,
      assetId: assetId,
      userId: userModel?.id ?? 0,
      quantity: null,
      rate: null,
      inventoryTypeId: null,
      ticketNumber: null,
      inventoryId: null,

      asset: null,
      inventoryType: null,
      user: null,
      vendor: null,
    };
    setFormData(values as InventoryLoadIn);
  };

  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    if (name === 'vendorId' && Number(value) !== 38) {
      setFormData((prevData) => ({
        ...prevData,
        inventoryId: null,
      }));
    }
    if (name === 'inventoryId') {
      const inventoryItem = inventoryListData.find(
        (x) => x.id === Number(value)
      );
      if (inventoryItem) {
        setFormData((prevData) => ({
          ...prevData,
          inventoryTypeId: inventoryItem.typeId,
        }));
      }
    }
  };
  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const getVendors = () => {
    if (userModel) {
      setIsLoading(true);
      return VendorApi.getVendorsList()
        .then((res) => {
          setvendorListData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.error(err);
          toast.error('Error');
          setIsLoading(false);
        });
    }
  };
  const getInventoryTypes = () => {
    if (userModel) {
      setIsLoading(true);
      return CommonApi.getInventoryTypes()
        .then((res) => {
          setinventoryTypeListData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.error(err);
          toast.error('Error');
          setIsLoading(false);
        });
    }
  };

  const getInventory = () => {
    if (userModel) {
      try {
        setIsLoading(true);
        return InventoryApi.getInventoryList()
          .then((res) => {
            setinventoryListData(res.data);
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    if (show) {
      handleResetFormValues();
      getVendors();
      getInventoryTypes();
      getInventory();
    }
  }, [show]);

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    setButtonDisabled(true);
    await InventoryApi.addUpdateInventoryLoadIn(formData)
      .then((res) => {
        if (res.data.success) {
          toast.success('Success');
          getUserLatestInspection();
          onCloseModal();
        }
      })
      .catch((err) => {
        setButtonDisabled(false);
        console.error(err);
        toast.error('Error');
        setIsLoading(false);
      });
  };

  function onCloseModal() {
    handleResetFormValues();
    setButtonDisabled(false);
    setShow(false);
  }

  return (
    <>
      <Modal show={show} size='xl' onClose={onCloseModal} popup>
        <Modal.Header>Add Load In</Modal.Header>
        <Modal.Body>
          <div className='relative'>
            {isLoading && <Loader />}
            <div className='w-full'>
              <form id='newAssetLoadInForm' onSubmit={onSubmit}>
                <div className='text-gray-500'>
                  <div className='grid grid-cols-[30%_70%] text-xl'>
                    <div className='flex'>
                      <div className='font-bold content-center'>Vendor:</div>
                    </div>
                    <Select
                      id='vendorId'
                      name='vendorId'
                      onChange={handleChangeSelect}
                      value={formData.vendorId ?? ''}
                      sizing='md'
                      required
                    >
                      <option value={''}>(Select)</option>
                      {vendorListData
                        // .filter((x) => x.typeId === assetType)
                        .sort((a, b) =>
                          (a.name ?? '').localeCompare(b.name ?? '')
                        )
                        .map((obj) => (
                          <option key={obj.id} value={obj.id}>
                            {obj.name}
                          </option>
                        ))}
                    </Select>
                  </div>
                  {Number(formData.vendorId ?? 0) === 38 && (
                    <div>
                      <hr className='bg-gray-300 h-[2px]'></hr>
                      <div className='grid grid-cols-[30%_70%] text-xl'>
                        <div className='flex'>
                          <div className='font-bold content-center'>
                            Inventory:
                          </div>
                        </div>
                        <Select
                          id='inventoryId'
                          name='inventoryId'
                          onChange={handleChangeSelect}
                          value={formData.inventoryId ?? ''}
                          sizing='md'
                          required
                        >
                          <option value={''}>(Select)</option>
                          {inventoryListData
                            // .filter((x) => x.typeId === assetType)
                            .sort((a, b) =>
                              (a.name ?? '').localeCompare(b.name ?? '')
                            )
                            .map((obj) => (
                              <option key={obj.id} value={obj.id}>
                                {obj.name}
                              </option>
                            ))}
                        </Select>
                      </div>
                    </div>
                  )}
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[30%_70%] text-xl'>
                    <div className='flex'>
                      <div className='font-bold content-center'>Type:</div>
                    </div>
                    <Select
                      id='inventoryTypeId'
                      name='inventoryTypeId'
                      onChange={handleChangeSelect}
                      value={formData.inventoryTypeId ?? ''}
                      sizing='md'
                      required
                      disabled={Number(formData.vendorId ?? 0) === 38}
                    >
                      <option value={''}>(Select)</option>
                      {inventoryTypeListData
                        // .filter((x) => x.typeId === assetType)
                        .sort((a, b) =>
                          (a.name ?? '').localeCompare(b.name ?? '')
                        )
                        .map((obj) => (
                          <option key={obj.id} value={obj.id}>
                            {obj.name}
                          </option>
                        ))}
                    </Select>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[30%_70%] text-xl'>
                    <div className='flex'>
                      <div className='font-bold content-center'>Quantity:</div>
                    </div>
                    <div className='w-full'>
                      <TextInput
                        id='quantity'
                        name='quantity'
                        type='text'
                        placeholder='Gallons...'
                        onChange={handleChangeInput}
                        value={formData.quantity ?? ''}
                        onKeyDown={(event) => {
                          if (onlyNumberInput(event)) {
                            event.preventDefault();
                          }
                        }}
                        sizing='md'
                        required
                        autoComplete='new-password'
                      />
                    </div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[30%_70%] text-xl'>
                    <div className='flex'>
                      <div className='font-bold content-center'>Ticket #:</div>
                    </div>
                    <div className='w-full'>
                      <TextInput
                        id='ticketNumber'
                        name='ticketNumber'
                        type='text'
                        placeholder=''
                        onChange={handleChangeInput}
                        value={formData.ticketNumber ?? ''}
                        sizing='md'
                        required
                        autoComplete='new-password'
                      />
                    </div>
                  </div>
                </div>
                <div className='flex justify-end pt-2'>
                  <Button
                    disabled={buttonDisabled}
                    type='submit'
                    className='buttonMain'
                    form='newAssetLoadInForm'
                    // onClick={() => onSubmit()}
                  >
                    Submit
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
